import { useParams } from "react-router-dom";
import SchedaRiassuntiva from "@/components/SchedaRiassuntiva";

export default function SchedaPubblicaPage() {
  const { token } = useParams();
  return (
    <div data-testid="scheda-pubblica-page" style={{ minHeight: "100vh", background: "#eef2f7", padding: "24px 16px" }}>
      <div style={{ maxWidth: 980, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
          <div style={{ fontWeight: 800, fontSize: 18, color: "#1e3a8a" }}>Istituto Canossa Diaz</div>
          <div style={{ fontSize: 13, color: "#64748b" }}>· Scheda Alunno (sola lettura)</div>
        </div>
        <SchedaRiassuntiva publicToken={token} />
      </div>
    </div>
  );
}
